/* RESPONSIBLE TEAM: team-reporting */
import ApplicationAdapter from 'embercom/adapters/application';

export default class ReportingNavigationFolderAdapter extends ApplicationAdapter {
  pathForType() {
    return 'reporting/reporting_navigation_folder';
  }
}
